import type { PlannerPreferences } from "./preferences";
import type { ItineraryLeg } from "./itinerary";

export class RequiredStopError extends Error {}
export const stopHour = (time: string) => Number(time.slice(0, 2)) + Number(time.slice(3)) / 60;

export function requiredStopError(prefs: PlannerPreferences): string | null {
  const stop = prefs.requiredStop;
  if (!stop) return null;
  if (!stop.nodeId || !/^([01]\d|2[0-3]):[0-5]\d$/.test(stop.time)
    || !Number.isInteger(stop.pauseMinutes) || stop.pauseMinutes < 0 || stop.pauseMinutes > 60) {
    return "Choose a mapped place, arrival time and a stop of up to 60 minutes.";
  }
  if (stopHour(stop.time) <= stopHour(prefs.startTime)
    || stopHour(stop.time) + stop.pauseMinutes / 60 > stopHour(prefs.endTime)) {
    return "Your timed stop must be after your start and leave time to reach your finish. Adjust the stop or your day times.";
  }
  return null;
}

export function requiredStopIncluded(legs: readonly ItineraryLeg[], stop: NonNullable<PlannerPreferences["requiredStop"]>): boolean {
  const at = stopHour(stop.time), until = at + stop.pauseMinutes / 60;
  return legs.some(leg => leg.kind === "stop" && leg.nodeId === stop.nodeId
    && leg.departHour <= at + 1e-8 && leg.arriveHour >= until - 1e-8);
}
